import { NewTabLink } from '@gonfalon/launchpad-experimental/NewTabLink';

import { trackDocumentationLinkClicked } from './analytics';

export interface DocumentationLinkProps {
  href: string;
  text?: string;
  onTrackEvent?(): void;
  component: string;
  className?: string;
  showIcon?: boolean;
}

// Ripped from static/ld/components
export const DocumentationLink = ({
  href,
  text = 'read the documentation',
  onTrackEvent,
  component,
  className,
  showIcon = true,
}: DocumentationLinkProps) => {
  const trackEvent = () => {
    onTrackEvent?.();
    trackDocumentationLinkClicked(href, {
      component,
      cta: text,
      path: window.location.pathname,
      type: 'link',
      url: window.location.href,
    });
  };

  return <NewTabLink href={href} text={text} onClick={trackEvent} className={className} showIcon={showIcon} />;
};
